import { useCategoryItemContext } from "../../../../../../services/context/CategoryItemContext";
import { useAppSelector } from "../../../../../../services/hooks/useReduxHooks";

import { reCheckItemDetails } from "../../../../../../utils/help/itemDetails/itemDetails";
import { isValidOffer } from "../../../../../../utils/help/offers/offers";
import {
  ItemOfferV1Type,
  RestaurantTypeEnum,
} from "../../../../../../utils/types";
import { DiscountedPrice } from "../../../../../global/DiscountedPrice";
import { ItemName } from "../../../../../shared/ItemName/ItemName";
import styles from "./CategoryItemDetails.module.scss";

export const CategoryItemText = () => {
  const { item } = useCategoryItemContext();

  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);
  const hasRoundingMethodAndLevel =
    !!restaurantInfo?.currencyRoundingMethod &&
    !!restaurantInfo?.currencyRoundingLevel;

  const itemStatusRedux = useAppSelector((state) => state.itemStatus);

  const restaurantType = useAppSelector(
    (state) => state.config.restaurantInfo?.type
  );

  // Offer cards have no menu item to detail.
  if (!item) {
    return null;
  }

  const details = reCheckItemDetails(
    itemStatusRedux,
    item,
    undefined,
    hasRoundingMethodAndLevel
  );

  const isEcommerce: boolean = restaurantType === RestaurantTypeEnum.ECOMMERCE;
  const itemDetails = details?.item;

  return (
    <>
      <div
        className={`${styles.menu_item_details_container} ${
          !isEcommerce ? styles.not_ecommerce : ""
        }`}
        id={`accordion-${itemDetails.id}`}
        data-testid={
          !isEcommerce
            ? `menu-item-${itemDetails.item_name}`
            : "menu-item-ecommerce"
        }
      >
        <div
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={styles.summary}
        >
          <div className={styles.accordion_item}>
            <div className={styles.item_details}>
              <div className={styles.item_name}>
                <ItemName item={item} />
              </div>
              <div
                className={`${styles.item_price} ${
                  isEcommerce ? styles.is_ecommerce : ""
                }`}
              >
                <DiscountedPrice
                  item={itemDetails}
                  isValidOffer={isValidOffer(
                    itemDetails.offer as ItemOfferV1Type
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
